/*
* Register global event listeners in this file
 */

export default (() => {

    const DOMStrings = {
        deleteDiscussionConfirm: '.js-delete-discussion-confirm',
        rejectDocumentConfirm: '.js-reject-document-confirm'
    };

    // register delete discussion links
    const registerDeleteDiscussionLinks = () => {
        let deleteLinks = document.querySelectorAll(DOMStrings.deleteDiscussionConfirm);
        Array.from(deleteLinks).forEach((link) => {
            link.addEventListener('click', async (event) => {
                event.preventDefault();
                let target = event.target.href;
                let result = await swal({
                    title: 'Opravdu chcete odstranit příspěvek?',
                    text: 'Příspěvek a všechny vložené odpovědi budou odstraněny.',
                    type: "warning",
                    showCancelButton: true,
                });
                if (result.value === true) {
                    window.location.href = target;
                }
            })
        });
    };

    // register reject document links
    const registerRejectDocumentLinks = () => {
        let deleteLinks = document.querySelectorAll(DOMStrings.rejectDocumentConfirm);
        Array.from(deleteLinks).forEach((link) => {
            link.addEventListener('click', async (event) => {
                event.preventDefault();
                let target = event.target.href;
                let result = await swal({
                    title: 'Opravdu chcete odstranit dokument?',
                    text: 'Dokument bude trvale odstraněn.',
                    type: "warning",
                    showCancelButton: true,
                });
                if (result.value === true) {
                    window.location.href = target;
                }
            })
        });
    };

    return {
        init: () => {
            window.onload = () => {
                registerDeleteDiscussionLinks();
                registerRejectDocumentLinks();
            };
        }
    };
})();
